import type { CreditNoteUpdateResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCreditNoteManuallyRedeem = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: { id: number }) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `credit-note/${data.id}/manually-redeem`,
      }).then(
        (response) =>
          apiV2AssertResponse<CreditNoteUpdateResponseType>(response).data,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.CreditNote],
      });
    },
  });
};
